import type { ReactNode } from 'react'

import { ErrorBoundary } from '@sentry/react'

const LogRenderExceptions = ({ children }: { children: ReactNode }) => {
  return <ErrorBoundary fallback={<div />}>{children}</ErrorBoundary>
}

export default LogRenderExceptions
